interface ErrorResponse {
    response?: {
        data?: {
            Error?: string;
            msg?: string;

        };
    };
    msg?: string;
}

export function getErrorMessageVerifyCode(error: ErrorResponse) {
    const errorMessageFromResponse = error.response?.data?.msg;

    if (errorMessageFromResponse) {
        return errorMessageFromResponse;
    }

    const errorMessage =
        error?.response?.data?.Error ||
        'Erro ao verificar o código, tente novamente mais tarde.';

    return errorMessage;
}
